module.exports = __webpack_public_path__ + "static/media/1.fd30fe1c.jpg";